import { Link } from "react-router-dom";
import HeroText from "../../components/heros/hero-text";
import CardDefault from "../../components/ui/cards/card-default/card-default";
import { PATH } from "../../constants/navigation";
import "./privacyPolicy.scss";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <HeroText
        title={"Privacy Policy"}
        text={"Informativa ai sensi dell'art. 13 GDPR"}
      />
      <section className="privacy-policy__intro">
        <h2 className="privacy-policy__intro-title">
          Privacy Policy di Rotoinfissioni S.r.l.
        </h2>
        <p className="privacy-policy__last-update">
          <span>Ultimo aggiornamento:</span>
          <span>Agosto 2026</span>
        </p>
        <p className="privacy-policy__intro-text">
          Questa informativa spiega come Rotoinfissioni S.r.l. tratta i dati
          personali in relazione all'utilizzo del sito www.rotoinfissioni.it (di
          seguito, “Sito”).
        </p>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          1. Titolare del trattamento
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            <span style={{ color: "#000000" }}>Rotoinfissioni S.r.l.</span>
            <span>
              Via Vittorio Emanuele II n.41/1 - 35026 Conselve (PD) - Italia
            </span>
            <span>Email: commerciale@rotoinfissioni.it</span>
            <span>PEC: rotoinfissionisrl@pec.it</span>
            <span>P.IVA: 04903730283</span>
          </p>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          2. Tipologia di dati trattati
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            <span>Il Sito non raccoglie dati personali dell'utente.</span>
            <span>I soli dati trattati sono:</span>
          </p>
          <ul className="privacy-policy__list">
            <li>
              <span style={{ color: "#000000" }}>
                Dati tecnici di navigazione
              </span>{" "}
              (indirizzi IP, log, dati aggregati anonimi);
            </li>
            <li>
              <span style={{ color: "#000000" }}>
                Dati tecnici di navigazione
              </span>
              , come descritto nella
              <Link to={PATH.cookie}>
                {" "}
                <span className="privacy-policy__list-link">Cookie Policy</span>
              </Link>
            </li>
          </ul>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          3. Finalità e base giuridica del trattamento
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            <span>
              Il trattamento dei dati avviene esclusivamente per le seguenti
              finalità:
            </span>
          </p>
          <ul className="privacy-policy__list">
            <li>
              <span style={{ color: "#000000" }}>
                Assicurare il corretto funzionamento del sito web
              </span>
              , garantendo la visualizzazione e l'accessibilità dei contenuti.
              <br />
              Base giuridica: legittimo interesse del Titolare (art. 6.1.f
              GDPR).
            </li>
            <li>
              <span style={{ color: "#000000" }}>
                Gestire la scelta dell'utente in materia di cookie
              </span>
              , registrando la preferenza (accettazione o rifiuto) tramite il
              localStorage del browser.
              <br />
              Base giuridica: obbligo di conformità normativa (art. 6.1.c GDPR).
            </li>
            <li>
              <span style={{ color: "#000000" }}>
                Visualizzare le mappe interattive di Google Maps
              </span>
              , fornite da Google LLC, solo dopo consenso esplicito dell’utente.
              <br />
              Base giuridica: consenso dell'utente (art. 6.1.a GDPR).
            </li>
          </ul>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          4. Modalità del trattamento
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            I dati vengono trattati in forma elettronica e per il tempo
            strettamente necessario alle finalità indicate. Non viene effettuata
            alcuna profilazione né comunicazione dei dati a terzi.
          </p>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          5. Conservazione dei dati
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <ul className="privacy-policy__list">
            <li>
              <span style={{ color: "#000000" }}>Dati tecnici:</span>{" "}
              temporaneamente per sicurezza e manutenzione (max 30 giorni).
            </li>
            <li>
              <span style={{ color: "#000000" }}>LocalStorage:</span> finché
              l'utente non cancella manualmente la preferenza.
            </li>
            <li>
              <span style={{ color: "#000000" }}>Cookie di terze parti:</span>{" "}
              secondo le politiche di Google.
            </li>
          </ul>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          6. Comunicazione e trasferimento dei dati
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            <span>
              I dati non vengono trasferiti fuori dallo Spazio Economico
              Europeo.
            </span>
            <span>
              Eventuali fornitori tecnici (es. hosting) operano come
              Responsabili del trattamento ai sensi dell'art. 28 GDPR.
            </span>
          </p>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">
          7. Diritti dell'interessato
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            <span>
              L'utente può esercitare i diritti previsti dagli artt. 15-22 GDPR
              (accesso, rettifica, cancellazione, limitazione, opposizione)
              scrivendo a commerciale@rotoinfissioni.it.
            </span>
            <span>
              Ha inoltre diritto di presentare reclamo al Garante per la
              Protezione dei Dati Personali (www.garanteprivacy.it).
            </span>
          </p>
        </CardDefault>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
